// extracted by mini-css-extract-plugin
export default {"customLinkRow":"custom_link-module___customLinkRow___b608a4a0"};